import classes from "./UpIcon.module.css";
import { BsFillArrowUpCircleFill } from "react-icons/bs";

const UpIcon = (props) => {
  return <BsFillArrowUpCircleFill className={props.className} />;
};

export default UpIcon;
